import { jsonToXlsx } from '@/utils/xlsExport/jsonToXlsx';
import staticData from './staticData';
import { pickOrderObj } from '@/utils/functions';
import i18n from '@/plugins/i18n';
import { formatFloat } from '@/utils/functions';
import moment from 'moment';

export const exportXls = (data) => {
  const cols = staticData(true).columns;
  jsonToXlsx({
    name: `${i18n.t('CPA report')} - ${moment().format('DD-MM-YYYY HH:mm')}`,
    headers: cols.map((c) => c.label),
    data: data.map((item) => {
      item.entry_value = formatFloat(item?.entry_value);

      return pickOrderObj(
        item,
        cols.map((c) => c.key)
      );
    })
  });
};

export default {
  exportXls
};
